<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii">TABLE OF CONTENTS</a></h1><a id="page_vii">
</a><p class="toc-chap"><a id="page_vii"></a><a href="#/006_Chapter01#ch-1">1. Boots</a></p>
<p class="toc-chap"><span href="#/007_Chapter02#ch-2" title="Link target outside of Sample">2. Wormwood</span></p>
<p class="toc-chap"><span href="#/008_Chapter03#ch-3" title="Link target outside of Sample">3. Pravda</span></p>
<p class="toc-chap"><span href="#/009_Chapter04#ch-4" title="Link target outside of Sample">4. Zones</span></p>
<p class="toc-chap"><span href="#/010_Chapter05#ch-5" title="Link target outside of Sample">5. Vultures</span></p>
<p class="toc-chap"><span href="#/011_Chapter06#ch-6" title="Link target outside of Sample">6. Something Odd Going On</span></p>
<p class="toc-chap"><span href="#/012_Chapter07#ch-7" title="Link target outside of Sample">7. Chernobyl AIDS</span></p>
<p class="toc-chap"><span href="#/013_Chapter08#ch-8" title="Link target outside of Sample">8. Merry Christmas</span></p>
<p class="toc-chap"><span href="#/014_Chapter09#ch-9" title="Link target outside of Sample">9. Minister and Morgue</span></p>
<p class="toc-chap"><span href="#/015_Chapter10#ch-10" title="Link target outside of Sample">10. Pripyat</span></p>
<p class="toc-chap"><span href="#/016_Chapter11#ch-11" title="Link target outside of Sample">11. Pioneers</span></p>
<p class="toc-chap"><span href="#/017_Chapter12#ch-12" title="Link target outside of Sample">12. Happy New Year</span></p>
<p class="toc-chap"><span href="#/018_Chapter13#ch-13" title="Link target outside of Sample">13. Not to Worry</span></p>
<p class="toc-chap"><span href="#/019_Chapter14#ch-14" title="Link target outside of Sample">14. The Author as Swine</span></p>
<p class="toc-chap"><span href="#/020_Chapter15#ch-15" title="Link target outside of Sample">15. Prohibited Zone</span></p>
<p class="toc-chap"><span href="#/021_Chapter16#ch-16" title="Link target outside of Sample">16. No Exit</span></p>
<p class="toc-chap"><span href="#/022_Epilog#ch-17" title="Link target outside of Sample">17. Epilog</span></p>
<p class="toc-sec"><span href="#/014_Chapter09#sec-1" title="Link target outside of Sample">Photo section</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?26477ac1